import React from 'react';
import phone from 'shared/utils/phone';
import { Space } from 'antd';
import Flag from 'components/Flag';

const PhoneNumber = ({ number }) => {
  const parsedNumber = number ? phone.parse(number) : null;

  if (parsedNumber?.isValid()) {
    return (
      <Space>
        <Flag countryCode={parsedNumber.country} />
        <span>{parsedNumber.formatInternational()}</span>
      </Space>
    );
  }

  return number;
};

export default PhoneNumber;
